export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";